pageId = 'page-notification-settings'

$ ->
  $('.wrapper').on 'change', "##{pageId} input[name='e16n']", (e) ->
    $option = $(@).closest('.option')

    $option.find('.choose-project').removeClass 'hide'
    if @value == 'on'
      $option.find('.project-list input:checkbox').prop 'checked', true
    else
      $option.siblings('.option').find('.select-shortcut, .project-list').addClass('hide')

  .on 'click', "##{pageId} .choose-project a", (e) ->
    $link = $(@).closest('.choose-project').addClass('hide')
    $option = $link.closest('.option')

    $option.find('input:radio').prop 'checked', true
    $option.find('.select-shortcut, .project-list').removeClass('hide')
    $option.find('.project-list input:checkbox').prop 'checked', true

  .on 'change', "##{pageId} input[name='d18n']", (e) ->
    d18nEnabled = @value == 'on'
    tower.d18n.requestPermission() if d18nEnabled and !tower.d18n.permitted()

  .on 'ajax:success', "##{pageId} .form", (e) ->
    tower.d18n_enabled = $('#radio-d18n-on').is(':checked')
    tower.d18n_muted = $('#mute_notification').val() == 'true'

  .on 'click', "##{pageId} .select-all", (e) ->
    $(@).closest('.option').find('.project-list input:checkbox').prop 'checked', true

  .on 'click', "##{pageId} .select-none", (e) ->
    $(@).closest('.option').find('.project-list input:checkbox').prop 'checked', false


$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  return unless tower.d18n.support()
  if Notification.permission == 'denied'
    $('.option-d18n-disabled').removeClass 'hide'
  else if Notification.permission == 'default'
    $('input[name="d18n"][value="off"]').prop('checked', true)

  $input = $('#mute_notification')
  $link = $('.link-mute-notification')
  $link.on 'click', ->
    $input.val $input.val() == 'false'
    $link.text if $input.val() == 'true' then '🔊 开启通知声音' else '🔇 关闭通知声音'
